import moment from "moment";

export default function importNote(note) {
  const id = note?.id ?? Math.floor(100000 + Math.random() * 900000);
  const time = note?.time ?? moment().utcOffset(0, true).valueOf();
  const title = note?.title ?? "";
  const subtitle = note?.subtitle ?? "";
  const color = note?.color ?? "purple";
  return {
    ...note,
    id,
    time,
    title,
    subtitle,
    color,
  };
}
